import { TableCell } from '@mui/material';
import { CountryFlag } from '@shared/ui/parts';
import { useViewCardDialog } from '@utils/dialogs-hooks';
import { formatCardNumber } from '@utils/helpers';
import { binsLogo } from '@utils/static';

export function TransactionCountryFlag({ row }) {
  return <CountryFlag countryCode={binsLogo[row.bank?.id]} />;
}

export function TransactionCardNumber({ row }) {
  return formatCardNumber(row.card_number);
}

export default function TransactionBankCell({ row }) {
  const { openViewCardDialog } = useViewCardDialog();

  return (
    <TableCell>
      <div className="transactionBankCell">
        <div>
          <button
            onClick={() => openViewCardDialog(row.card_id)}
            className="dashed-btn"
          >
            <p>
              <TransactionCardNumber row={row} />
            </p>
          </button>
          <div className="secondary-text transactionBankCell__icon">
            <TransactionCountryFlag row={row} />
            {row.bank?.public_name}
          </div>
        </div>
      </div>
    </TableCell>
  );
}
